import React from 'react';
import { Badge } from '@thinkific/chalk/react-components';

interface ModeratorBadgeProps {
  children: string;
}

export const ModeratorBadge = ({ children }: ModeratorBadgeProps) => (
  <Badge emphasis="medium" label={children} variant="primary" />
);

export default ModeratorBadge;
